import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const DeviceDetailsContactInfo = ({ contactName, contactEmail, contactPhoneNumber }) => {
    const hasContactInfo = contactName || contactEmail || contactPhoneNumber;

    if (!hasContactInfo) return '';

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {contactName && <Typography variant='body3'>{contactName}</Typography>}
            {contactEmail && (
                <Typography variant='body3' sx={{ wordBreak: 'break-all' }}>
                    {contactEmail}
                </Typography>
            )}
            {contactPhoneNumber && <Typography variant='body3'>{contactPhoneNumber}</Typography>}
        </Box>
    );
};

DeviceDetailsContactInfo.propTypes = {
    contactName: PropTypes.string,
    contactEmail: PropTypes.string,
    contactPhoneNumber: PropTypes.string,
};

export default DeviceDetailsContactInfo;
